import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import {StandartInput} from '@components/form/StandartInput';
import {Select} from '@components/form/Select';
import FormLabel from '@material-ui/core/FormLabel';
import {InputPhone} from '@components/form/InputPhone';
import {SimpleDialog} from "@components/form/SimpleDialog";
import InputAdornment from "@material-ui/core/InputAdornment";
import RemoteAutocompleteWithSearch from '@components/form/RemoteAutocompleteWithSearch';

import * as Enum from './enum/constants';
import {history} from '~/router/history';
import clsx from 'clsx';

const merge = require('deepmerge');

export class NewTtnComponent extends React.Component {
    state = {
        open: false,
        senders: [],
        form: {
            client_uuid: '',
            client_phone: '',
            //delivery
            deliveryType: 'W2W',
            description: '',
            paidByRecipient: 'true',
            declaredPrice: '',
            postPay: '',
            //parcel
            weight: 0,
            width: 0,
            length: 0,
            height: 0,
            //recipient
            firstName: '',
            lastName: '',
            phone: '',
            //address
            postcode: '',
            city: '',
            street: '',
            house_number: '',
            apartment_number: '',
        },
        errors: {}
    };

    async componentDidUpdate(prevProps, prevState) {
        if (this.state.open && this.state.open !== prevState.open) {
            const config = await this.props.getClients();
            const names = this.props?.name?.split(' ') || [];
            const order = await this.props.getOrderDetails(this.props.order_id);
            this.setState({
                senders: config.senders,
                config: config.config,
                form: {
                    ...this.state.form,
                    client_uuid: config.senders[0]?.client_uuid,
                    client_phone: config.senders[0]?.phone,
                    description: this.props.description,
                    phone: this.props.phone,
                    lastName: names?.[0] || '',
                    firstName: names?.[1] || '',
                    postPay: this.props.postPay,
                    declaredPrice: this.props.declaredPrice,
                    postcode: this.props.postcode,
                    city: this.props.city,
                    weight: this.props.weight,
                    width: Math.max.apply(null, (order?.data?.products.map(row => row.variation.product.settings.dimension_width || 0) || 0)),
                    length: Math.max.apply(null, (order?.data?.products.map(row => row.variation.product.settings.dimension_deep || 0) || 0)),
                    height: order?.data?.products.reduce((accumulator, row) => accumulator + row.variation.product.settings.dimension_height * row.amount, 0).toFixed(0),
                }
            });
        }
    }

    selectClient(client_uuid) {
        this.setState({
            form: {
                ...this.state.form,
                client_uuid: client_uuid,
                client_phone: this.state.senders.filter(row => row.client_uuid === client_uuid)?.[0]?.phone,
            }
        })
    }

    createTtn = () => {
        this.props.createTTN(this.props.order_id, this.state.form).then((data) => {
            if (data.errors) {
                this.setState({errors: data.errors});
            } else {
                if (data.data.uuid) {
                    this.setState({open: false});
                    if (this.props.onSubmitRedirect) {
                        this.props.onSubmitRedirect(data);
                    } else {
                        history.go();
                    }
                }
            }
        });
    }

    render() {
        let { classes } = this.props;

        return (
            <SimpleDialog
                fullWidth={true}
                maxWidth={'lg'}
                open={this.state.open}
                onClose={(e) => this.setState({open: false})}
                title={'Создание ТТН УкрПошты'}
                icon={<Button
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.setState({open: true})
                    }}
                    variant="outlined"
                    color="primary"
                >
                    ТТН
                </Button>}
                actions={[
                    (<Button
                        onClick={(e) => {
                            e.stopPropagation();
                            this.createTtn();
                        }}
                        color="primary" variant="contained"
                    >
                        Сохранить
                    </Button>),
                ]}
            >
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12} md={6}>
                        <FormLabel
                            component="legend"
                            className={classes.newTTN_formLabel}
                            style={{marginTop: this.state.senders.length > 1 ? '30px' : '0px'}}
                        >Отправитель</FormLabel>

                        <Select
                          name={'client_uuid'}
                          value={this.state.form.client_uuid}
                          options={this.state.senders.map((row, i) => {
                              return {
                                  value: row.client_uuid,
                                  label: row.name,
                              }
                          })}
                          displayEmpty={false}
                          label="Отправитель"
                          className={classes.input}
                          variant={'outlined'}
                          margin={'normal'}
                          size={'small'}
                          fullWidth
                          onChange={({target: {value}}) => this.selectClient(value)}
                        />
                        <InputPhone
                            name={''}
                            value={this.state.form.client_phone}
                            label="Телефон отправителя"
                            onChange={(phone) => {}}
                            className={classes.input}
                            variant={'outlined'}
                            margin={'normal'}
                            size={'small'}
                            disabled={true}
                            fullWidth
                        />

                        <FormLabel
                            component="legend"
                            className={classes.newTTN_formLabel}
                        >Оплата</FormLabel>

                        <Select
                            name={'deliveryType'}
                            value={this.state.form.deliveryType}
                            options={Enum.deliveryTypes}
                            displayEmpty={false}
                            label="Технология доставки"
                            className={classes.input}
                            variant={'outlined'}
                            margin={'normal'}
                            size={'small'}
                            fullWidth
                            onChange={({target: {value}}) => this.setState(merge(this.state,{form: {deliveryType: value}}))}
                        />
                        <Grid container spacing={3} className={classes.gridSubContainer_row2}>
                            <Grid item xs={12} lg={6}>
                                <Select
                                    name={'paidByRecipient'}
                                    value={this.state.form.paidByRecipient}
                                    options={Enum.paidByRecipient}
                                    displayEmpty={false}
                                    label="Плательщик отправления"
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                    onChange={({target: {value}}) => this.setState(merge(this.state,{form: {paidByRecipient: value}}))}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormLabel
                            className={clsx([classes.newTTN_formLabel, classes.formLabel_margin_sm])}
                            style={{marginTop: this.state.senders.length > 1 ? '30px' : '0px'}}
                            component="legend"
                        >Получатель</FormLabel>

                        <Grid container spacing={3} className={classes.gridSubContainer_row3}>
                            <Grid item xs={12} md={6}>
                                <StandartInput
                                    name={'firstName'}
                                    value={this.state.form.firstName}
                                    errors={this.state.errors}
                                    label="Имя"
                                    onChange={({target: {value}}) => {
                                        this.setState(merge(this.state, {form: {firstName: value}}));
                                    }}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <StandartInput
                                    name={'lastName'}
                                    value={this.state.form.lastName}
                                    errors={this.state.errors}
                                    label="Фамилия"
                                    onChange={({target: {value}}) => {
                                        this.setState(merge(this.state, {form: {lastName: value}}));
                                    }}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <InputPhone
                            name={'phone'}
                            value={this.state.form.phone}
                            errors={this.state.errors}
                            label="Телефон получателя"
                            onChange={(phone) => this.setState(merge(this.state, {form: {phone: phone}}))}
                            className={classes.input}
                            variant={'outlined'}
                            margin={'normal'}
                            size={'small'}
                            fullWidth
                        />
                        <StandartInput
                          name={'postcode'}
                          autoFocus
                          value={this.state.form.postcode}
                          errors={this.state.errors}
                          label="Индекс получателя"
                          onChange={({target: {value}}) => {
                              this.setState(merge(this.state, {form: {postcode: value}}));
                          }}
                          className={classes.input}
                          variant={'outlined'}
                          margin={'normal'}
                          size={'small'}
                          fullWidth
                        />
                        { this.state.form.deliveryType !== 'W2W'
                            ? (
                                <Grid container spacing={3} className={classes.gridSubContainer_StreetRef}>
                                    <Grid item xs={12}>
                                        <RemoteAutocompleteWithSearch
                                            name={'city'}
                                            initOnRuntime
                                            initialValue={{
                                                value: this.state.form.city,
                                                label: this.state.form.city,
                                            }}
                                            url={`/api/v1/modules/ukrposhta/address/city`}
                                            searchFieldName={'FindByString'}
                                            value={this.state.form.city}
                                            errors={this.state.errors}
                                            label="Город"
                                            onChange={(e, target) => this.setState(merge(this.state, {form: { city: target?.label}}))}
                                            disableClearable={false}
                                            className={classes.input}
                                            variant={'outlined'}
                                            margin={'normal'}
                                            size={'small'}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <StandartInput
                                          name={'street'}
                                          value={this.state.form.street}
                                          errors={this.state.errors}
                                          label="Улица"
                                          onChange={({target: {value}}) => {
                                              this.setState(merge(this.state, {form: {street: value}}));
                                          }}
                                          className={classes.input}
                                          variant={'outlined'}
                                          margin={'normal'}
                                          size={'small'}
                                          fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <StandartInput
                                          name={'house_number'}
                                          value={this.state.form.house_number}
                                          errors={this.state.errors}
                                          label="Дом"
                                          onChange={({target: {value}}) => {
                                              this.setState(merge(this.state, {form: {house_number: value}}));
                                          }}
                                          className={classes.input}
                                          variant={'outlined'}
                                          margin={'normal'}
                                          size={'small'}
                                          fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <StandartInput
                                          name={'apartment_number'}
                                          value={this.state.form.apartment_number}
                                          errors={this.state.errors}
                                          label="Квартира"
                                          onChange={({target: {value}}) => {
                                              this.setState(merge(this.state, {form: {apartment_number: value}}));
                                          }}
                                          className={classes.input}
                                          variant={'outlined'}
                                          margin={'normal'}
                                          size={'small'}
                                          fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            ) : null
                        }
                        <StandartInput
                            name={'description'}
                            value={this.state.form.description}
                            errors={this.state.errors}
                            label="Описание груза"
                            onChange={({target: {value}}) => this.setState(merge(this.state, {form: {description: value}}))}
                            className={classes.input}
                            variant={'outlined'}
                            margin={'normal'}
                            size={'small'}
                            fullWidth
                        />

                        <FormLabel component="legend" className={classes.newTTN_formLabel}>Груз</FormLabel>

                        <Grid container spacing={3} className={classes.gridSubContainer_row3}>
                            <Grid item xs={12} md={4}>
                                <StandartInput
                                    name={'width'}
                                    value={this.state.form.width}
                                    errors={this.state.errors}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                    label="Ширина"
                                    onChange={({target: {value}}) => this.setState(merge(this.state, {form: {width: value}}))}
                                    InputProps={{
                                        startAdornment: (<InputAdornment position="start">см</InputAdornment>),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <StandartInput
                                    name={'length'}
                                    value={this.state.form.length}
                                    errors={this.state.errors}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                    label="Длина"
                                    onChange={({target: {value}}) => this.setState(merge(this.state, {form: {length: value}}))}
                                    InputProps={{
                                        startAdornment: (<InputAdornment position="start">см</InputAdornment>),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <StandartInput
                                    name={'height'}
                                    value={this.state.form.height}
                                    errors={this.state.errors}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                    label="Высота"
                                    onChange={({target: {value}}) => this.setState(merge(this.state, {form: {height: value}}))}
                                    InputProps={{
                                        startAdornment: (<InputAdornment position="start">см</InputAdornment>),
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} className={classes.gridSubContainer_row3}>
                            <Grid item xs={12} md={4}>
                                <StandartInput
                                    name={'weight'}
                                    value={this.state.form.weight}
                                    errors={this.state.errors}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                    label="Общий вес"
                                    onChange={({target: {value}}) => this.setState(merge(this.state,{form: {weight: value}}))}
                                    InputProps={{
                                        startAdornment: (<InputAdornment position="start">кг</InputAdornment>),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <StandartInput
                                  name={'declaredPrice'}
                                  value={this.state.form.declaredPrice}
                                  errors={this.state.errors}
                                  className={classes.input}
                                  variant={'outlined'}
                                  margin={'normal'}
                                  size={'small'}
                                  fullWidth
                                  label="Оценочная"
                                  onChange={({target: {value}}) => this.setState(merge(this.state,{form: {declaredPrice: value}}))}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <StandartInput
                                  name={'postPay'}
                                  value={this.state.form.postPay}
                                  errors={this.state.errors}
                                  className={classes.input}
                                  variant={'outlined'}
                                  margin={'normal'}
                                  size={'small'}
                                  fullWidth
                                  label="Сумма наложки"
                                  onChange={({target: {value}}) => this.setState(merge(this.state,{form: {postPay: value}}))}
                                />
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </SimpleDialog>
        );
    }
}
